import McpDocsFeature from '../../features/docs/mcp-feature';

export default function McpDocsPage() {
  return <McpDocsFeature />;
}
